



import { Component, Vue, Prop } from 'vue-property-decorator'

type Locale = string

@Component({
  name: 'formatted-date',
})
export default class FormattedDateComponent extends Vue {
  @Prop() date!: string
  defaultLocale: Locale = 'en-GB'
  // TODO: get localization from OW
  private readonly locale = this.defaultLocale
  dateToString = ''

  shortFormatDate = (locale: Locale): Intl.DateTimeFormat =>
    new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    })

  timeFormatDate = (locale: Locale): Intl.RelativeTimeFormat => new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })

  formattedDate(): void {
    const today = Date.now()
    const endDate = new Date(this.date)
    const ms = today - endDate.getTime()
    const seconds = Math.floor(ms / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)

    if (seconds < 60) {
      setTimeout(() => this.formattedDate(), 60 * 1000)
      this.dateToString = this.timeFormatDate(this.locale).format(0, 'seconds')
    } else if (minutes < 60) {
      setTimeout(() => this.formattedDate(), 60 * 1000)
      this.dateToString = this.timeFormatDate(this.locale).format(-minutes, 'minutes')
    } else if (hours < 24) {
      setTimeout(() => this.formattedDate(), 1000 * 60 * (60 - (minutes - hours * 60)))
      this.dateToString = this.timeFormatDate(this.locale).format(-hours, 'hours')
    } else {
      this.dateToString = this.shortFormatDate(this.locale).format(endDate)
    }
  }

  created(): void {
    this.formattedDate()
  }
}
